import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ContentSections, useContentBlocks } from '../components/content/ContentSections';
import { StaticPageLayout } from '../components/layout/StaticPageLayout';
import { TELEGRAM_SUPPORT_URL } from '../utils/constants';

export function SupportPage() {
  const { t } = useTranslation();
  const blocks = useContentBlocks('staticPages.support.blocks');

  return (
    <StaticPageLayout titleKey="staticPages.support.title" subtitleKey="staticPages.support.subtitle">
      <ContentSections blocks={blocks} />
      <div className="mt-6 flex flex-wrap gap-3">
        <a
          href={TELEGRAM_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center h-11 px-5 rounded-full bg-brand-accent text-white font-heading font-semibold text-sm"
        >
          {t('staticPages.support.ctaButton')}
        </a>
        <Link
          to="/tickets/create"
          className="inline-flex items-center justify-center h-11 px-5 rounded-full border border-brand-accent/50 text-brand-accent font-heading font-semibold text-sm"
        >
          {t('staticPages.support.ticketCta')}
        </Link>
      </div>
    </StaticPageLayout>
  );
}
